import type { V10ControlRoomSection } from "../adapters/v10-phase-model.js";
import { V10_SECTION_LABELS } from "../adapters/v10-phase-model.js";
import {
  domainRecordsForSection,
  type V10ProjectRoomDomainRecord,
} from "../adapters/v10-project-room-domain-atlas.js";

export function V10DomainAtlasNav({
  section,
  onNavigateSection,
}: {
  readonly section: V10ControlRoomSection;
  readonly onNavigateSection: (section: V10ControlRoomSection) => void;
}) {
  const records = domainRecordsForSection(section);
  return (
    <nav className="v10-domain-atlas" aria-label="Domain records" data-testid="v10-domain-atlas">
      <h3>Domain records (single truth source)</h3>
      <ul>
        {records.map((record: V10ProjectRoomDomainRecord) => (
          <li key={record.id} data-testid={record.panelTestId}>
            <button type="button" className="v10-btn v10-btn--ghost" onClick={() => onNavigateSection(record.section)}>
              {record.label}
            </button>
            <span className="v10-muted">{record.truthSource}</span>
          </li>
        ))}
      </ul>
      <p className="v10-muted">
        Current section: {V10_SECTION_LABELS[section]} — records link to canonical API truth, not duplicate stores.
      </p>
    </nav>
  );
}
